import React from 'react'

/**
 * Used to pass down the index of the theme color
 */
export const ThemeColorIndexContext = React.createContext<number>(0)
